import React, { FC } from "react";
import { UseFormRegister } from "react-hook-form";
import { AppointmentOptionDto } from "../../../../../Model/Blocks/Waitlist/AppointmentOptionDto.csharp";
import {InlineMessage} from "../InlineMessage/InlineMessage";

export type RadioInputProps = {
  label: string;
  name: string;
  register: UseFormRegister<any>;
  options: AppointmentOptionDto[];
  error?: any;
  getValues: any;
};

export const RadioInput: FC<RadioInputProps> = ({
  label,
  name,
  register,
  options,
  error,
  getValues,
}) => {
  const getPreselect = (index: number) => {
    const option = options[index];
    if (option.preselected && getValues().remoteContact == option.label) {
      return {
        checked: true,
      };
    }
    return {};
  };

  return (
    <fieldset className="RadioInput" aria-describedby={`errorId-${name}`}>
      <div className="RadioInput__group">
      <legend className="RadioInput__legend">{label}</legend>
      
      {options && options.map((option, index) => {
        const id =`${name}-${option.label}`;
        return (
        <div key={id} className="RadioInput__wrapper">
          <div className="RadioInput__row">
            <input
              {...register(name)}
              className="RadioInput__input"
              type="radio"
              name={name}
              value={option.label.toLowerCase()}
              {...getPreselect(index)}
              id={id}
            />
            <label className="RadioInput__label" htmlFor={id}>{option.label}</label>
          </div>
        </div>
        )
        })
      }
      
      
      {error?.message && (
          <InlineMessage variant="error" id={`errorId-${name}`} msg={error.message} />
      )}
      </div>
    </fieldset>
  );
};
